import React from "react";
import "./OnboardingStepper.css";

const OnboardingStepper = ({ steps, currentStep, themeMode, documentSigningCompleted }) => {
  const progressPercentage = (currentStep / (steps.length - 1)) * 100;
  
  return (
    <div className={`onboarding-stepper ${themeMode}`}>
      <div 
        className="stepper-header"
        style={{
          '--progress-width': progressPercentage
        }}
      >
        {steps.map((step, index) => {
          // Check if step should be marked as completed
          const isCompleted = index < currentStep || (index === 0 && documentSigningCompleted);
          const isActive = index === currentStep;
          
          return (
            <div 
              key={step.id}
              className={`stepper-item ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`}
            >
              <div className="stepper-number">
                {isCompleted ? (
                  <svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.5 4.5L6 12L2.5 8.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                ) : (
                  String(step.id).padStart(2, '0')
                )}
              </div>
              <div className="stepper-content">
                <div className="stepper-title">{step.title}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OnboardingStepper; 